import React, { useEffect } from "react";
import DOMPurify from "dompurify";
import { useAnnouncementsStore } from "../../../../stores/use-announcements-store";
import {
  StyledEditableTextarea,
  StyledTextareaCalculator,
} from "../../../../components/inline-edit/styled";

function EditableText({
  announcementId,
  isEditable,
  value,
  propKey,
  disableNewLine = false,
  resizeWidth = false,
  minHeight,
}) {
  const { updateAnnouncement } = useAnnouncementsStore((state) => ({
    updateAnnouncement: state.updateAnnouncement,
  }));

  const textareaRef = React.useRef();
  const textareaHelperRef = React.useRef();

  useEffect(() => {
    if (!announcementId || !isEditable || !propKey) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const helperHeight = entry.contentRect.height;
      const helperWidth = entry.contentRect.width;
      if (textareaRef?.current) {
        textareaRef.current.style.height = `${helperHeight}px`;
        if (resizeWidth) textareaRef.current.style.width = `${helperWidth}px`;
      }
    });
    const element = document.getElementById(
      `${announcementId}-announcement-editable-${propKey}`
    );
    if (element) {
      resizeObserver.observe(element);
    }
  }, [announcementId, isEditable, value, propKey, resizeWidth]);

  return (
    <>
      {isEditable ? (
        <>
          <StyledEditableTextarea
            ref={textareaRef}
            value={value}
            onInput={(e) => {
              if (
                disableNewLine &&
                e.nativeEvent.inputType === "insertLineBreak"
              ) {
                return;
              }
              updateAnnouncement({ key: propKey, value: e.target.value });
            }}
            style={{ width: "100%", overflow: "hidden" }}
          />
          <StyledTextareaCalculator
            id={`${announcementId}-announcement-editable-${propKey}`}
            ref={textareaHelperRef}
            width="auto"
            style={{ minHeight: minHeight || "0.7em" }}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}
          />
        </>
      ) : (
        value
      )}
    </>
  );
}

export default EditableText;
